var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPen1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7578 2.92676L18.2734 1.44238C17.8047 0.973633 17.1406 0.700195 16.5156 0.700195C15.8906 0.700195 15.2266 0.973633 14.7578 1.44238L11.8281 4.37207L10.5 5.7002L0.96875 15.2314L0.5 19.6846C0.421875 20.2314 0.851562 20.7002 1.39844 20.7002C1.4375 20.7002 1.47656 20.7002 1.51562 20.7002L5.96875 20.2314L15.5 10.7002L16.8281 9.37207L19.7578 6.44238C20.7344 5.46582 20.7344 3.90332 19.7578 2.92676ZM5.10938 18.4346L2.49219 18.708L2.76562 16.0908L11.7891 7.02832L13 5.81738L15.3828 8.2002L14.1719 9.41113L5.10938 18.4346ZM18.4297 5.11426L16.7109 6.87207L14.3281 4.48926L16.0859 2.77051C16.2422 2.61426 16.4375 2.5752 16.5156 2.5752C16.5938 2.5752 16.7891 2.61426 16.9453 2.77051L18.4297 4.25488C18.6641 4.48926 18.6641 4.87988 18.4297 5.11426Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen1);
export default __webpack_public_path__ + "static/media/pen-1.55c92f17.svg";
export { ForwardRef as ReactComponent };